"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityDataValidationDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const data_validation_entity_1 = require("./data-validation.entity");
const file_upload_entity_1 = require("./file-upload.entity");
const look_up_entity_1 = require("./look-up.entity");
let OpportunityDataValidationDocumentMap = class OpportunityDataValidationDocumentMap {
    constructor(id, dataValidationId, documentId, documentTypeLid, taskId) {
        this.id = id;
        this.dataValidationId = dataValidationId;
        this.documentId = documentId;
        this.documentTypeLid = documentTypeLid;
        this.taskId = taskId;
    }
};
exports.OpportunityDataValidationDocumentMap = OpportunityDataValidationDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataValidationDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "data_validation_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataValidationDocumentMap.prototype, "dataValidationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataValidationDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataValidationDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "task_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityDataValidationDocumentMap.prototype, "taskId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => data_validation_entity_1.DataValidation, (dataValidation) => dataValidation.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "data_validation_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataValidationDocumentMap.prototype, "dataValidation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, (fileUpload) => fileUpload.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataValidationDocumentMap.prototype, "document", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityDataValidationDocumentMap.prototype, "documentType", void 0);
exports.OpportunityDataValidationDocumentMap = OpportunityDataValidationDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_data_validation_document_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, Number])
], OpportunityDataValidationDocumentMap);
